import { load } from 'js-yaml';
import { parse } from 'jsonref';
export const SymbolHref = Symbol('url');
export const SymbolError = Symbol('error');
export const fetchJSON = async (url, options) => {
    try {
        const fullURL = new URL(url, window.location.href).href;
        const result = await parse(fullURL, {
            scope: fullURL,
            retriever: async (url) => {
                try {
                    const response = await fetch(url, {
                        redirect: 'follow',
                    });
                    if (!response.ok) {
                        throw new Error(`HTTP ${response.status} ${response.statusText}: "${url}"`);
                    }
                    const contentType = response.headers.get('content-type');
                    const isJSON = !!contentType && contentType.indexOf('application/json') !== -1;
                    const text = await response.text();
                    const result = isJSON ? JSON.parse(text) : load(text);
                    if (typeof result === 'object' && result !== null) {
                        result[SymbolHref] = url;
                    }
                    return result;
                }
                catch (error) {
                    if (options?.ignoreErrors) {
                        return {
                            [SymbolError]: error,
                            [SymbolHref]: url,
                        };
                    }
                    throw error;
                }
            },
        });
        return result;
    }
    catch (error) {
        if (options?.ignoreErrors) {
            return {
                [SymbolError]: error,
                [SymbolHref]: url,
            };
        }
        throw error;
    }
};
//# sourceMappingURL=fetchJSON.js.map